













import { Component, Emit, Inject, Model } from "vue-property-decorator";
import { Vue, Prop, Watch, Provide } from "vue-property-decorator";
import EventBus from "@/utils/eventBus";

@Component({
  components: {}
})
export default class VipDialogClock extends Vue {
  private count: any = 0;
  private timeArr: any = [];

  private beforeDestroy() {}

  private destroyed() {
    EventBus.$off("vipnav-countdown");
  }

  private mounted() {
    EventBus.$on("vipnav-countdown", (payload: any) => {
      const time = payload.time;
      this.count = time;
    });
  }

  // 监听计时时间，显示计时内容
  @Watch("count", { immediate: false })
  private changeTime(time: number, num: number, oldVal: number) {
    const h =
      Math.floor(time / 3600) < 10
        ? "0" + Math.floor(time / 3600)
        : Math.floor(time / 3600);
    const m =
      Math.floor((time / 60) % 60) < 10
        ? "0" + Math.floor((time / 60) % 60)
        : Math.floor((time / 60) % 60);
    const s =
      Math.floor(time % 60) < 10
        ? "0" + Math.floor(time % 60)
        : Math.floor(time % 60);
    this.timeArr = [h, m, s];
  }
}
